const PaymentSuccess = () => import('@/pages/payment/payment-success.vue');
const PaymentCancel = () => import('@/pages/payment/payment-cancel.vue');

export default [
  {
    path: '/payment/stripe/success',
    name: 'StripePaymentSuccess',
    component: PaymentSuccess,
    meta: {
      layout: 'payment-layout',
    },
  },
  {
    path: '/payment/cash/success',
    name: 'CashPaymentSuccess',
    component: PaymentSuccess,
    meta: {
      layout: 'payment-layout',
    },
  },
  {
    path: '/payment/cancel',
    name: 'PaymentCancel',
    component: PaymentCancel,
    meta: {
      layout: 'payment-layout',
    },
  },
];
